import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const INITIAL_STATE = {
  sidebarDisplay: true,
  settings: false,
  open: false,
  SideBarOpts: false,
  QuickLinks: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: INITIAL_STATE,
  reducers: {
    display: (state) => {
      state.sidebarDisplay = true;
    },
    hide: (state) => {
      state.sidebarDisplay = false;
    },
    displaySettings: (state) => {
      state.settings = true;
    },
    hideSettings: (state) => {
      state.settings = false;
    },
    displayQuickLinks: (state) => {
      state.QuickLinks = true;
    },
    hideQuickLinks: (state) => {
      state.QuickLinks = false;
    },
    expand: (state) => {
      state.open = true;
    },
    collapse: (state) => {
      state.open = false;
    },
    SideBarOpts: (state, action) => {
      state.SideBarOpts = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { SideBarOpts, expand, collapse, display, hide, displaySettings, hideSettings, displayQuickLinks, hideQuickLinks } =
  sidebarSlice.actions;
export default sidebarSlice.reducer;
